import { render, staticRenderFns } from "./statisticsCard.vue?vue&type=template&id=e97adbb6"
import script from "./statisticsCard.vue?vue&type=script&lang=js"
export * from "./statisticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports